import axios from 'axios';
import { COMMENT_LIKE_UNLIKE } from './types';
import api from '../../../utils/api';

export default {
  async likeUnlike(_, post) {
    try {
      await axios(api.postsLikeUnlike.create(post));
    } catch (error) {
      console.error('postsLikeUnlike/likeUnlike failed', {
        payload: post,
        status: error.response && error.response.status,
        data: error.response && error.response.data,
        message: error.message,
      });
      throw error;
    }
  },
  async CommentlikeUnlike({ commit }, data) {
    commit(COMMENT_LIKE_UNLIKE, { add: data.add, url: data.comment });
    await axios(api.postsLikeUnlike.create({ comment: data.comment }));
  },
};
